import { ApplicationController } from "../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    static targets = [ "closeProfileButton" ]

    initialize() {}

    connect() {
	const params = new URLSearchParams(window.location.search)
	const onboarder = params.get("onboarder")

	if (onboarder === "subscription") {
	    localStorage.setItem("onboarder", "subscription")
	    const url = new URL(window.location.href)
	    url.searchParams.delete("onboarder")
	    Turbolinks.visit(url.toString(), { action: "replace" })
	} else if (localStorage.getItem("onboarder") === "subscription") {
	    localStorage.removeItem("onboarder")

	    $(this.element).animateCss('fadeIn')

	    this.element.classList.add('active')
	    $(this.element.querySelector('.my-profile-container')).animateCss('slideInRight', () => {
		document.querySelector('body').classList.add('no-overflow')
	    })
	    setTimeout(() => {
		this.element.querySelector('[data-item-box="subscriptions"] a.single-item').click()
		this.element.querySelector('[data-item-box="subscriptions"] .single-item-content a.add-btn').click()
	    }, 0)
	}
    }

    open(event) {
	event.preventDefault()

	$(this.element).animateCss('fadeIn')

	$(this.element).addClass('active').find('.my-profile-container').animateCss('slideInRight', () => {
	    $("body").addClass('no-overflow')
	})
    }

    close(event) {
	if (!$(this.element).hasClass('active')) {
	    return
	}

	if (this.closeProfileButtonTarget.contains(event.target)) {
	    event.preventDefault()
	}

	if (event && !this.closeProfileButtonTarget.contains(event.target) && this.element.querySelector('.my-profile-container').contains(event.target)) {
	    return
	}

	if (this.element.classList.contains('order-just-completed')) { return }

	$(this.element).animateCss('fadeOut')

	$(this.element).find('.my-profile-container').animateCss('slideOutRight', () => {
	    this.element.classList.remove('active')
	    this.element.classList.remove('loading')
	    this.element.querySelectorAll('.profile-item-box').forEach(el => {
		if(el.querySelector(".single-item").dataset.firstLoad !== undefined) {
		    el.querySelector(".single-item").dataset.firstLoad = "false"
		    // Lister Reset
		    el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-lister").replaceChildren()

		    // Load More Reset
		    if(el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-loadmore")) {
			el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-loadmore").replaceChildren()
		    } else {
			el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-lister").insertAdjacentHTML('afterend', '<div class="scroll-wrapper-loadmore"></div>')
		    }

		    // Add Reset
		    if(el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-add")) {
			el.querySelector(".single-item-content .top-heading .add-btn").dataset.firstLoad = "false"
			el.querySelector(".single-item-content .scroll-wrapper .scroll-wrapper-add .single-item-content .scroll-wrapper").replaceChildren()
		    }
		}
	    })
	    $(this.element).find(".single-item-content").removeClass('active')
	    $("body").removeClass('no-overflow')
	})
    }

    openMenuItem(event) {
	// Only works for preventing default behaviour of anchor tags which don't have data-remote=true.
	// It will still trigger data-remote=true links. That is what we want in this case.
	// We can remove this line if all anchor tags have data-remote=true.
	event.preventDefault()

	if(event.currentTarget.dataset.remote == "true") {
	    if(event.currentTarget.dataset.firstLoad == "true") {
		event.stopImmediatePropagation()
	    } else {
		event.currentTarget.closest('[data-controller="marketing--profiles"]').classList.add('loading')
		event.currentTarget.dataset.firstLoad = "true"
	    }
	}
	event.currentTarget.nextElementSibling.classList.add("active")
    }

    openAddMenuItem(event) {
	// Only works for preventing default behaviour of anchor tags which don't have data-remote=true.
	// It will still trigger data-remote=true links. That is what we want in this case.
	// We can remove this line if all anchor tags have data-remote=true.
	event.preventDefault()

	if(event.currentTarget.dataset.remote == "true") {
	    if(event.currentTarget.dataset.firstLoad == "true") {
		event.stopImmediatePropagation()
	    } else {
		event.currentTarget.closest('[data-controller="marketing--profiles"]').classList.add('loading')
		event.currentTarget.dataset.firstLoad = "true"
	    }
	}
	event.currentTarget.closest(".single-item-content").querySelector('.scroll-wrapper .scroll-wrapper-add .single-item-content').classList.add("active")
    }

    openAddSubMenuItem(event) {
	event.preventDefault()
	event.currentTarget.closest(".scroll-wrapper").querySelector(`${event.currentTarget.closest('form').getAttribute("action")}`).classList.add('active')
    }

    closeMenuItem(event) {
	event.preventDefault()
	event.currentTarget.closest('.single-item-content').classList.remove("active")
    }

    loadMoreOnScroll(event) {
	if (event.currentTarget.querySelector('.scroll-wrapper-loadmore a') && (event.currentTarget.scrollTop > (event.currentTarget.scrollHeight - event.currentTarget.offsetHeight - 600))) {
	    Rails.fire(event.currentTarget.querySelector('.scroll-wrapper-loadmore a'), "click")
	}
    }

    showLoader(event) {
	this.element.classList.add('loading')
    }
}
